import * as yup from 'yup'
import { GigsafeDefaultRoleName } from 'src/constants/gigsafe-user/enums'

const DEFAULT_ROLE_NAMES: string[] = Object.values(GigsafeDefaultRoleName)

/**
 * `GigsafeUserRolesApiService.update` throws `Default roles are not modifiable` for any of these,
 * and the form is read-only when one is selected.
 */
export const isDefaultGigsafeRole = (name: string): boolean => {
  return DEFAULT_ROLE_NAMES.includes(name)
}

/**
 * Mirrors `GigsafeUserRoleCreatePayloadDto`. The reserved-name rule is the backend's
 * `@IsNotIn(Object.values(GigsafeDefaultUseRoles))`, checked here so the message is useful
 * instead of a raw validation array.
 */
export const gigsafeRoleFormValidator = yup.object({
  roleId: yup.string(),
  name: yup
    .string()
    .trim()
    .required('Role name is required')
    .test('not-a-default-role', 'That name is reserved for a built-in role', (value) => {
      return !isDefaultGigsafeRole(value ?? '')
    }),
  permissions: yup.array(yup.string().required()).min(1, 'Select at least one permission'),
})
